import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from './Select.module.less';
import selctDown from '../../static/select_down.png';
import selctUp from '../../static/select_up.png';

export default ({
  selectStyle = {},
  handleChange,
  options = [],
  defaultValue,
  primary,
  className,
  selectModal,
}) => {
  const [active, setActive] = useState(defaultValue);
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    setActive(defaultValue || options[0]);
  }, [defaultValue]);

  const handleOption = option => () => {
    setActive(option);
    if (handleChange) {
      handleChange(option);
    }
  };

  const handleFocus = () => {
    setModalVisible(true);
  };
  const handleBlur = () => {
    setModalVisible(false);
  };
  return (
    <div
      className={styles.select_box}
      style={selectStyle}
      onMouseOver={handleFocus}
      onMouseLeave={handleBlur}
    >
      <div className={classNames(styles.select_text, className || '')}>
        {active && active.text}
        {active && !primary && (
          <i
            className={classNames(
              'iconfont',
              {
                'icon-arrow_down_small': !modalVisible,
              },
              {
                'icon-arrow_up_small': modalVisible,
              },
              styles.select_icon,
            )}
          />
        )}
        {active && primary && (
          <>
            {!modalVisible && <img src={selctDown} className={styles.select_img} alt="" />}
            {modalVisible && <img src={selctUp} className={styles.select_img} alt="" />}
          </>
        )}
      </div>
      {modalVisible && (
        <ul className={classNames(styles.select_modal, selectModal)}>
          {options.map(item => (
            <li
              key={item.name}
              onClick={handleOption(item)}
              className={classNames({ [styles.active]: active && active.name === item.name })}
            >
              {item.text}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
